import React from 'react';
import { CalanderIcon } from '../../../tempIcons/CalendarIcon';
import { FailIcon } from '../../../tempIcons/FailIcon';
const iconSize = { width: 64, height: 64 };
export const defaultEmptyState = {
    icon: React.createElement(CalanderIcon, Object.assign({}, iconSize)),
    title: 'No data found',
};
export const defaultErrorState = {
    icon: React.createElement(FailIcon, Object.assign({}, iconSize)),
    title: 'An error occurred when creating the table',
    subTitle: "Please, try reloading the page once. If this doesn't solve the problem, contact support",
};
export var ScrollPosition;
(function (ScrollPosition) {
    ScrollPosition["start"] = "start";
    ScrollPosition["middle"] = "middle";
    ScrollPosition["end"] = "End";
    ScrollPosition["none"] = "none";
})(ScrollPosition || (ScrollPosition = {}));
//# sourceMappingURL=constants.js.map